import routes from '../routes/index.routes';
import { BidderDomains } from '../../pages/bidder-domains/bidder-domains.page';

export const BidderDomainsRouter = [
	{
		path: routes.bidderDomains.index(),
		element: <BidderDomains />,
	},
];
